import React from 'react'
import ReloadOutlined from '@ant-design/icons/ReloadOutlined'
import PropTypes from 'prop-types'

// Css
import './ButtonReset.scss'

export const ButtonReset = ({ onClick, ...props }) => {
  return (
    <div className="x-button-reset" onClick={onClick} {...props}>
      <ReloadOutlined className="reset-icon" />
      <span className="reset-label">Reset all</span>
    </div>
  )
}

ButtonReset.propTypes = {
  onClick: PropTypes.func,
}

ButtonReset.defaultProps = {
  onClick: () => {},
}

export default ButtonReset
